import React, { useState } from 'react';
import {Box, Card, CardContent, TextField, InputAdornment, SvgIcon, makeStyles, Button, Table, TableBody, TableCell, TableHead, TablePagination, TableRow} from '@material-ui/core';
import Page from 'src/components/Page';
import PropTypes from 'prop-types';
import { Search as SearchIcon } from 'react-feather';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { v4 as uuid } from 'uuid';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  otherButton: {
    marginBottom: theme.spacing(3)
  },
}));



/******************* TOOLBAR *******************/
const Toolbar = ({ className, ...rest }) => {
    const classes = useStyles();
  
    return (
    <div>
        <Button className={classes.otherButton} color="primary" variant="outlined">Add New Foreign Firm Worker</Button>

        <Card>
            <CardContent>
                <Box maxWidth={500}>
                <TextField fullWidth InputProps={{startAdornment: (
                        <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                            <SearchIcon />
                        </SvgIcon>
                        </InputAdornment>
                    )
                    }} placeholder="Search (worker names, firm names, vocational tags, ..)" variant="outlined"/>
                </Box>
            </CardContent>
        </Card>
    </div>
    );
  };
  
Toolbar.propTypes = {
  className: PropTypes.string
};
/******************* TOOLBAR *******************/



/********************* DATA ********************/
const data = [
    {
        id: uuid(),
        nameSurname: 'Ekaterina Tankova',
        age: 35,
        gender: 'Male',
        vocationalTags: ['painter', 'tailor'],
        firm: 'X Corp'
    },
    {
        id: uuid(),
        nameSurname: 'Noah De Vries',
        age: 25,
        gender: 'Male',
        vocationalTags: ['painter', 'tailor', 'driver'],
        firm: 'Y Corp'
    },
    {
        id: uuid(),
        nameSurname: 'Lucas Jansen',
        age: 18,
        gender: 'Male',
        vocationalTags: ['runner', 'painter', 'tailor'],
        firm: 'Z Corp'
    },
    {
        id: uuid(),
        nameSurname: 'Emma De Jong',
        age: 40,
        gender: 'Female',
        vocationalTags: ['walker', 'painter'],
        firm: 'T Corp'
    },
    {
        id: uuid(),
        nameSurname: 'Mees Bakker',
        age: 45,
        gender: 'Male',
        vocationalTags: ['runner', 'walker', 'painter', 'tailor', 'teacher'],
        firm: 'U Corp'
    },
];
/********************* DATA ********************/



/******************** RESULTS ******************/
const Results = ({ className, hiredWorkers, ...rest }) => {
    const classes = useStyles();
    const [selectedWorkIds, setSelectedWorkIds] = useState([]);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const handleLimitChange = (event) => { setLimit(event.target.value); };
  
    const handlePageChange = (event, newPage) => {
      setPage(newPage);
    };
  
    return (
    <Card>
        <PerfectScrollbar>
            <Box minWidth={1050}>
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell style={{width: "15%"}}>Worker</TableCell>
                    <TableCell style={{width: "5%"}}>Age</TableCell>
                    <TableCell style={{width: "10%"}}>Gender</TableCell>
                    <TableCell style={{width: "20%"}}>Vocational Tags</TableCell>
                    <TableCell style={{width: "20%"}}>Firm</TableCell>
                    <TableCell style={{width: "10%"}}>Created At</TableCell>
                    <TableCell style={{width: "20%"}}>Actions</TableCell>
                </TableRow>
                </TableHead>

                <TableBody>
                {hiredWorkers.slice(page * limit, page * limit + limit).map((worker) => (
                <TableRow hover key={worker.id} selected={selectedWorkIds.indexOf(worker.id) !== -1}>
                    <TableCell >{worker.nameSurname}</TableCell>
                    <TableCell >{worker.age}</TableCell>
                    <TableCell >{worker.gender}</TableCell>
                    <TableCell >{worker.vocationalTags.join(', ')}</TableCell>
                    <TableCell >{worker.firm}</TableCell>
                    <TableCell >Not implemented yet</TableCell>
                    <TableCell ><Button variant="outlined">View / Edit</Button></TableCell>
                </TableRow>
                ))}
                </TableBody>
            </Table>
            </Box>
        </PerfectScrollbar>
        <TablePagination component="div" 
            count={hiredWorkers.length}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 50, 100]} />
    </Card>
    );
  };
  
Results.propTypes = {
    className: PropTypes.string,
    hiredWorkers: PropTypes.array.isRequired
};
/******************** RESULTS ******************/



const HiredWorkers = () => {
  const classes = useStyles();
  const [hiredWorkers] = useState(data);

  return (
    <Page className={classes.root} title="Hired Workers">
      <Toolbar />
      <Results hiredWorkers={hiredWorkers} />
    </Page>
  );
};

export default HiredWorkers;
